

// import { useNavigate } from "react-router-dom";

// const CategoryBar = ({ activeCategory, onCategoryChange, onAllClick }) => {
//   const navigate = useNavigate();

//   const categories = [
//     "Fresh",
//     "Vegetables",
//     "Rice",
//     "Meat",
//     "Dairy",
//     "Offers",
//   ];

//   return (
//     <div className="mm-catbar">
//       <div
//         className="mm-catbar-all"
//         onClick={() => navigate("/categorieList")}
//       >
//         <i className="fas fa-bars"></i>
//         <span>All</span>
//       </div>

//       <ul className="mm-catbar-menu">
//         {categories.map(cat => (
//           <li
//             key={cat}
//             className={activeCategory === cat ? "active" : ""}
//             onClick={() => {
//               onCategoryChange(cat);

//               // 🔥 SPECIAL CASE: OFFERS
//               if (cat === "Offers") {
//                 navigate(`/categorieList?offerType=all`);
//               } else {
//                 navigate(`/categorieList?category=${cat}`);
//               }
//             }}
//           >
//             {cat}
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default CategoryBar;


import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CategoryBar = ({ activeCategory, onCategoryChange, onAllClick }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

const categories = [
  { key: "Fresh", label: t("cat_fresh") },
  { key: "Vegetables", label: t("cat_vegetables") },
  { key: "Rice", label: t("cat_rice") },
  { key: "Meat", label: t("cat_meat") },
  { key: "Dairy", label: t("cat_dairy") },
  { key: "Offers", label: t("cat_offers") },
];

  return (
    <div className="mm-catbar">
      <div
        className="mm-catbar-all"
        onClick={() => navigate("/categorieList")}
      >
        <i className="fas fa-bars"></i>
        <span>{t("cat_all")}</span>
      </div>

      <ul className="mm-catbar-menu">
          {categories.map(cat => (
            <li
              key={cat.key}
              className={activeCategory === cat.key ? "active" : ""}
              onClick={() => {
                onCategoryChange(cat.key);

                if (cat.key === "Offers") {
                  navigate(`/categorieList?offerType=all`);
                } else {
                  navigate(`/categorieList?category=${cat.key}`);
                }
              }}
            >
              {cat.label}
            </li>
          ))}
      </ul>
    </div>
  );
};

export default CategoryBar;